export const MESHBOT_ON_SAVE = 'MeshBot successfully saved';
export const TOAST_MESSAGE_ON_ERROR = 'ezlo.toast.error.text.something_went_wrong';
